import { ADD_LR_POST_REQUEST, ADD_LR_POST_SUCCESS, ADD_LR_POST_ERROR } from '../actions/addLongReadPost';
import { updateObjectById } from "../utilites/newReducerHelpers";
var initialData = {
    isFetching: false,
    isError: false,
    data: {}
};
var initialState = {};
export function addLongReadPostReducer(state, action) {
    var _a, _b, _c, _d;
    if (state === void 0) { state = initialState; }
    if (!((_a = action.payload) === null || _a === void 0 ? void 0 : _a.lgId))
        return state;
    switch (action.type) {
        case ADD_LR_POST_REQUEST:
            return updateObjectById(state, (_b = action.payload) === null || _b === void 0 ? void 0 : _b.lgId, { isFetching: true }, initialData);
        case ADD_LR_POST_SUCCESS:
            // return { ...state, isFetching: false, data: action.payload.data }
            return updateObjectById(state, (_c = action.payload) === null || _c === void 0 ? void 0 : _c.lgId, { isFetching: false, data: action.payload.data.data }, initialData);
        case ADD_LR_POST_ERROR:
            // return { ...state, isFetching: false, isError: true }
            return updateObjectById(state, (_d = action.payload) === null || _d === void 0 ? void 0 : _d.lgId, { isFetching: false, isError: true }, initialData);
        default:
            return state;
    }
}
;
export function getAddLongread(state, lgId) {
    return state.addlgpost[lgId] || initialData;
}
//# sourceMappingURL=addLongReadPost.js.mapimport { ADD_LR_POST_REQUEST, ADD_LR_POST_SUCCESS, ADD_LR_POST_ERROR } from '../actions/addLongReadPost';
import { updateObjectById } from "../utilites/newReducerHelpers";
var initialData = {
    isFetching: false,
    isError: false,
    data: {}
};
var initialState = {};
export function addLongReadPostReducer(state, action) {
    var _a, _b, _c, _d;
    if (state === void 0) { state = initialState; }
    if (!((_a = action.payload) === null || _a === void 0 ? void 0 : _a.lgId))
        return state;
    switch (action.type) {
        case ADD_LR_POST_REQUEST:
            return updateObjectById(state, (_b = action.payload) === null || _b === void 0 ? void 0 : _b.lgId, { isFetching: true }, initialData);
        case ADD_LR_POST_SUCCESS:
            // return { ...state, isFetching: false, data: action.payload.data }
            return updateObjectById(state, (_c = action.payload) === null || _c === void 0 ? void 0 : _c.lgId, { isFetching: false, data: action.payload.data.data }, initialData);
        case ADD_LR_POST_ERROR:
            // return { ...state, isFetching: false, isError: true }
            return updateObjectById(state, (_d = action.payload) === null || _d === void 0 ? void 0 : _d.lgId, { isFetching: false, isError: true }, initialData);
        default:
            return state;
    }
}
;
export function getAddLongread(state, lgId) {
    return state.addlgpost[lgId] || initialData;
}
//# sourceMappingURL=addLongReadPost.js.map